document.addEventListener('DOMContentLoaded', initIconColumns);
document.addEventListener('shopify:section:load', initIconColumns);

function initIconColumns() {
  document.querySelectorAll('[data-icol-track]').forEach((track) => {
    if (track.dataset.icolInitialized === 'true') return;
    track.dataset.icolInitialized = 'true';

    const swiperEl = track.querySelector('[data-icol-swiper]');
    const dotsEl = track.querySelector('[data-icol-dots]');
    if (!swiperEl) return;

    const mql = window.matchMedia('(max-width: 749px)');
    let swiperInstance = null;

    function buildDots(count) {
      if (!dotsEl) return;
      dotsEl.innerHTML = '';
      for (let i = 0; i < count; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'icol-dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === 0) dot.classList.add('is-active');
        dot.addEventListener('click', () => {
          if (swiperInstance) swiperInstance.slideTo(i);
        });
        dotsEl.appendChild(dot);
      }
    }

    function setActiveDot(index) {
      if (!dotsEl) return;
      dotsEl.querySelectorAll('.icol-dot').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function enableSlider() {
      if (swiperInstance || typeof Swiper === 'undefined') return;

      const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
      buildDots(slideCount);

      swiperInstance = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: false,
        watchOverflow: true,
        on: {
          slideChange: function () {
            setActiveDot(this.activeIndex);
          },
        },
      });
    }

    function disableSlider() {
      if (!swiperInstance) return;
      swiperInstance.destroy(true, true);
      swiperInstance = null;
      if (dotsEl) dotsEl.innerHTML = '';
    }

    function handleBreakpoint(e) {
      if (e.matches) {
        enableSlider();
      } else {
        disableSlider();
      }
    }

    handleBreakpoint(mql);
    mql.addEventListener('change', handleBreakpoint);
  });
}
